export default __webpack_public_path__ + "static/media/documents.5836ad92.svg";